import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import IconButton from "../IconButton";

const LayoutControl = ({ t, component, open, onClose }) => {
    const handleOnCancel = () => {
        return new Promise(resolve=> {
            onClose && onClose();
            resolve();            
        });
    }

    return (
        <div className={classNames("layoutControl", { open: open })}>
            <div className={classNames("layoutControlHeader")} onClick={handleOnCancel}>
                <IconButton isIcon={true} iconName={"cancel"} tooltipText={t("basic.CANCEL_BUTTON")} onClick={handleOnCancel} />
            </div>
            <div className={classNames("layoutControlData")}>
                {component}
            </div>            
        </div>
    );
}

export default withTranslation()(LayoutControl);